// extracted by mini-css-extract-plugin
module.exports = {"Spacer":"_37EbKUB5"};